export default class License {
    constructor (id, key, name) {
        this.id = id
        this.key = key
        this.name = name
    }
}
